import React from 'react';
import SliderBar from '../Components/SliderBar';
import { Card, Col, Container, Image, ListGroup, Row } from 'react-bootstrap';
import './Home.css';
import chairman from '../Components/BoardofDirectors/shree_ram_panday.jpg';
import News_data from '../Components/News.json';
import { Link } from 'react-router-dom';
import '../Pages/NewsList';

const Home = () => {
  return (
    <>
      <SliderBar />

      <Container
        className="container20"
        style={{ textAlign: 'center' }}
      >
        <Row
          className="background"
          style={{ marginTop: '30px' }}
        >
          <Col className="col1">
            <h3
              className="heading"
              style={{ textAlign: 'center' }}
            >
              <span>Nilganga Hydropower Company Ltd.</span>
            </h3>

            <p className="paragraph">
              Our goal is to build one of the most comprehensive web portals
              with regard to Nepal's water resources. This, we believe, can and
              will contribute to a better understanding and utilization of this
              vital resource. However, we are aware that this is only possible
              by partnering with as many institutions (national or
              international) that have a stake in this sector, be they from the
              government, private sector, or communities. If you (or your
              agency) are interested in finding out more about how you can
              partner with us.
            </p>

            <h6 className="anchor6">
              <Link to="/introduction">Read More...</Link>
            </h6>

            <h2 className="heading10">
              21
              <span style={{ fontSize: '20px' }}>MW</span>
            </h2>

            <div
              className="paragraph"
              style={{
                fontSize: '20px',
                color: '#016ab9',
                textAlign: 'center',
                fontWeight: 'bold',
                marginBottom: '30px'
              }}
            >
              Installed Capacity
            </div>
          </Col>

          <Col className="col1">
            <h3 className="heading">
              Message From Chairman
            </h3>

            <Image
              className="img"
              src={chairman}
              height={150}
              width={150}
              style={{
                borderRadius: '100%',
                padding: '10px'
              }}
              alt="Chairman"
            />

            <p className="paragraph">
              I heartily welcome all the visitors to NHC (Nilganga Hydropower
              Company) website. It is our effort to provide related information
              about NHC activities to all using online media as soon as
              possible. Please don't forget to make your comments and
              suggestions to make this website more fruitful and efficient.
            </p>

            <h6 className="anchor6">
              <Link to="/directors">Read More...</Link>
            </h6>
          </Col>
        </Row>
      </Container>

      <Container className="container_news">
        <Row className="row23">
          <h1 className="heading_latest">
            Latest News
          </h1>

          {News_data.map((news) => (
            <Col key={news.id}>
              <Card className="card">
                <ListGroup.Item style={{ border: 'none', padding: 0 }}>
                  <Link
                    to={`/News/${news.id}`}
                    style={{
                      textDecoration: 'none',
                      color: '#333'
                    }}
                  >
                    <Card.Img
                      className="card_img"
                      variant="top"
                      src={news["Card.Img"]}
                      alt={news["Card.Title"]}
                    />

                    <Card.Body>
                      <Card.Title className="card_title">
                        {news["Card.Title"]}
                      </Card.Title>

                      {/* Fixed Warning */}
                      <div className="card_text">
                        <div
                          className="card_paragraph"
                          style={{ lineHeight: 1 }}
                        >
                          {news["Card.Text"]}
                        </div>

                        <div
                          className="card_link"
                          style={{
                            color: '#82d5ec',
                            fontWeight: 'bold',
                            marginTop: '10px'
                          }}
                        >
                          Read More...
                        </div>
                      </div>
                    </Card.Body>
                  </Link>
                </ListGroup.Item>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
};

export default Home;